import { render, staticRenderFns } from "./VehicleOwnership.vue?vue&type=template&id=366445d6&scoped=true&"
import script from "./VehicleOwnership.vue?vue&type=script&lang=js&"
export * from "./VehicleOwnership.vue?vue&type=script&lang=js&"
import style0 from "./VehicleOwnership.vue?vue&type=style&index=0&id=366445d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366445d6",
  null
  
)

export default component.exports